/** The order reference for THIS browser session.
 *
 *  WHY THIS EXISTS: the platform's order lookup requires the consumer's EMAIL as
 *  an input alongside the confirmation code. That email is not ours to store
 *  server-side, so it lives here -- in the consumer's own browser, for their own
 *  session -- and is sent with each request.
 *
 *  This is NOT a record of the order. The order's existence on the platform is
 *  the only record of it. If this is empty (a fresh browser, or a link opened
 *  weeks later) the confirmation page simply ASKS the consumer for their email,
 *  which is the same thing the platform's own lookup form does.
 */
const key = (code) => `wbm.order.${code}`;

export const rememberOrderRef = (order) => {
  const code = order?.orderConfirmationCode;
  if (!code) return;
  try {
    window.sessionStorage.setItem(
      key(code),
      JSON.stringify({ code, email: order.guestEmail ?? null }),
    );
  } catch {
    /* a full or blocked sessionStorage just means we ask for the email */
  }
};

/** The email for this code, or null if we must ask the consumer for it. */
export const orderEmail = (code) => {
  if (!code) return null;
  try {
    const raw = window.sessionStorage.getItem(key(code));
    return raw ? JSON.parse(raw).email || null : null;
  } catch {
    return null;
  }
};
